.cnc-required-field-marker {
  color: var(--negative-text-default);
}
